import { types, flow, castToSnapshot } from 'mobx-state-tree';
import { navigate, errorResponse } from 'js/services/Network';
import { pick } from 'lodash';

import { makeRequest, url } from 'js/services/Network';
import { castEventToValue } from 'js/services/FormTools';
import analytics from 'js/services/Analytics';

import SteppedPage from 'js/stores/SteppedPage';
import Address from '../types/Address';

const BuyerSignupPage = types
  .model('BuyerSignupPage', {
    modalIsVisible: false,
    hasEnteredFullName: false,
    full_name: '',
    phone_number: '',
    address: types.optional(Address, {}),
  })
  .actions(self => {
    return {
      getStepRoute(step) {
        return url('buyer-signup-page', {
          step,
        });
      },

      initStep(step) {
        self.modalIsVisible = false;
        return self;
      },

      submit: flow(function* submit() {
        let response;
        if (!self.isSubmitting) {
          self.isSubmitting = true;
          self.error = null;

          try {
            response = yield makeRequest('buyer-signup', self, pick(self, ['full_name', 'phone_number', 'address']));
            console.log("sign up response: ",response);
            //analytics.track('buyer onboarding submit');
            navigate(url('my-tokens-page'));
          } catch (error) {
            self.error = errorResponse(error);
          }

          self.isSubmitting = false;
        }
        return response;
      }),

      nextDetail() {
        if (!self.hasEnteredFullName && self.full_name) {
          self.hasEnteredFullName = true;
        } else {
          self.nextStep();
        }
      },
      editName() {
        self.hasEnteredFullName = false;
      },
      setFullName(full_name) {
        self.full_name = castEventToValue(full_name);
        return self;
      },
      setPhoneNumber(phone_number) {
        self.phone_number = castEventToValue(phone_number);
        return self;
      },
      addressSaved(savedAddress) {
        self.address.setAddress(castToSnapshot(savedAddress));
        self.modalIsVisible = false;
      },

      openModal() {
        self.modalIsVisible = true;
        return self;
      },
      closeModal() {
        self.modalIsVisible = false;
        return self;
      },
    };
  });

export default types.compose(
  SteppedPage,
  BuyerSignupPage,
);
